import {Component, Inject, OnInit, PLATFORM_ID} from '@angular/core';
import {MarketProduct} from '@app/marketplace/products/_models/product.interface';
import {UrlService} from '@app/services/url.service';
import {FingerprintService} from '@app/services/fingerprint.service';
import {ActivatedRoute, Router} from '@angular/router';
import {ProductService} from '@app/marketplace/products/_services/product.service';
import {StorageService} from '@app/services/storage.service';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {Store} from '@ngrx/store';
import {TrackingComponent} from '@app/shared/components/tracking/tracking.component';
import {finalize} from 'rxjs/operators';
import {ViewTypeEnum} from '@app/marketplace/core/enum/viewTypeEnum';
import {ProductDetailsDlgComponent} from '@app/marketplace/products/product-details-dlg/product-details-dlg.component';

@Component({
  selector: 'app-products-walmart',
  templateUrl: './products-walmart.component.html',
  styleUrls: ['./products-walmart.component.css']
})
export class ProductsWalmartComponent extends TrackingComponent implements OnInit {

  products: MarketProduct[] = [];
  payload: any;
  loading$: boolean;

  theme = { 'min-width': '220px', 'min-height': '219px', background: '#f1f1f1' };

  constructor(private urlService: UrlService,
              private fingerprintService: FingerprintService,
              private route: ActivatedRoute,
              private productService: ProductService,
              private storageService: StorageService,
              private modalService: NgbModal,
              private router: Router,
              private store: Store<any>,
              @Inject(PLATFORM_ID) private platformId) {
    super(urlService, fingerprintService, null, route, 'stu_btn_market_walmart');
    this.payload = {
      pageIndex: 1,
      pageSize: 4,
      pagingStrategy: 0,
      locationType: 0,
      locations: null,
      locationResolver: false,
      filter: {
        searchTerms: this.mostPopularProducts(['Alimentos en Conserva', 'alimentos', 'cereales', 'sazones', 'great value nuts', 'cookies pack']),
      },
      provider: 3,
      categoryCode: '',
      supplierCode: '',
    };
  }

  ngOnInit(): void {
    this.updatePayload(1);
  }

  updatePayload(tab: number) {
    switch (tab) {
      case 1: this.payload.filter.searchTerms = this.mostPopularProducts(['Alimentos en Conserva', 'alimentos', 'cereales', 'sazones', 'great value nuts', 'cookies pack']); break;
      case 2: this.payload.filter.searchTerms = this.mostPopularProducts(['ollas de presion', 'refrigeradores', 'lavadora', 'blender', 'olla arrocera', 'horno', 'microwave']); break;
      case 3: this.payload.filter.searchTerms = this.mostPopularProducts(['soap', 'champu', 'perfume blue for women', 'perfume blue for men', 'desodorante gilllette', 'gel de baño', 'cuchilla de afeitar']); break;
      default: this.payload.filter.searchTerms = this.mostPopularProducts(['Alimentos en Conserva', 'alimentos', 'cereales', 'sazones', 'great value nuts', 'cookies pack']);
    }
    this.getProducts();
  }
  getProducts() {
    this.loading$ = true;
    const location = this.storageService.getCurrentLocation('location');
    if (location && location.isSuccess == true) {
      this.payload.locationType = location?.locationType || 0;
      this.payload.locations = location?.locations || null;
    }
    this.productService.ListProducts(this.payload).pipe(finalize(() => this.loading$ = false)).subscribe((result: any) => {
      if (result && result.data) {
        result.data.map(data => {
          data.ratingsCounter = new Array(Number(data.rating.toFixed(0)));
        });
        const res = result.data.length < 4 ? result.data.filter(x => x.price > 0) : result.data.filter(x => x.price > 0).slice(0, 4);
        this.products = res;
      }
    });
  }

  public pushToCart(product: any, tab) {
    const itemImg = $(`#${tab}-${product.code}`).find('img').eq(0);
    this.flyToElement($(itemImg), product, ViewTypeEnum.ProductList, this.store);
  }

  shortText(text: string) {
    if (text.length > 50) {
      return text.slice(0, 50) + '...';
    }
  }

  openDetails(product: any) {
    const modalRef = this.modalService.open(ProductDetailsDlgComponent, {size: 'xl', modalDialogClass: 'book-address'});
    modalRef.componentInstance.code = product.code;
    modalRef.componentInstance.provider = product.productProvider;
    modalRef.componentInstance.origin = 'home';
    modalRef.result.then(
      (result: boolean) => {
        if (result) {
          this.router.navigate([`/market/productos-compras-cuba-online/walmart/${product.code}`]);
        }
      }, () => {}
    );
  }

  mostPopularProducts(arr: string[]): string {
    const indiceAleatorio = Math.floor(Math.random() * arr.length);
    return arr[indiceAleatorio];
  }
}
